import moment from 'moment';
import { Row } from 'react-table';
import { PortTargetEventTypeEnum } from '../PortDetails/PortEvents';
import { t } from 'i18next';
import { TargetPortEvent } from 'ais-facade-api/api';
import { CountryFlag } from 'CountryFlag/CountryFlag';
import { Link } from 'react-router-dom';
import { useFormatMoment } from 'app/hooks/useFormatMoment';
import { Icon } from "../../components";
import { PortActionCell } from "../../components/PortActionCell";

import styles from './VesselDetails.module.scss';
import clsx from 'clsx';

export const columns = [
  {
    Header: 'Name',
    accessor: 'name',
    Cell: ({ row: { original: port } }: { row: Row<TargetPortEvent> }) =>
      typeof port?.port?.name === 'string' ? (
        typeof port.port?.key === 'string' ? (
          <Link to={`/ports/${port.port.key}`} className={styles.link_in_table}>
            {port.port.name}
          </Link>
        ) : (
          <>{port.port.name}</>
        )
      ) : (
        <>&mdash;</>
      ),
    canSort: true,
  },
  {
    Header: 'UN/LOCODE',
    accessor: 'locode',
    Cell: ({ row: { original: port } }: { row: Row<TargetPortEvent> }) => (
      <>
        {typeof port?.port?.locode === 'string' && typeof port?.port?.un === 'string' ? (
          `${port.port.un} ${port.port.locode}`
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: 'Country',
    accessor: 'country',
    Cell: ({ row: { original: port } }: { row: Row<TargetPortEvent> }) => (
      <>
        {port?.port?.meta?.countryName && port?.port?.countryCode ? (
          <>
            <CountryFlag countryCode={port.port.countryCode?.toLocaleLowerCase()} />
            {port.port.meta.countryName} ({port.port.countryCode})
          </>
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: 'EventType',
    accessor: 'eventType',
    Cell: ({ row: { original: port } }: { row: Row<TargetPortEvent> }) => (
      <>
        {port.eventType === PortTargetEventTypeEnum.LowerTheAnchor ? (
          t('LowerTheAnchor')
        ) : port.eventType === PortTargetEventTypeEnum.RaiseTheAnchor ? (
          t('RaiseTheAnchor')
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: 'EventDate',
    accessor: 'eventDate',
    Cell: ({ row: { original: port } }: { row: Row<TargetPortEvent> }) => {
      const formatMoment = useFormatMoment();
      return <>{port.eventDateTime ? formatMoment(moment(port.eventDateTime)) : <>&mdash;</>}</>;
    },
    canSort: true,
    sortBy: 'EVENT_DATE_TIME',
  },
  {
    Header: <Icon name="more-icon" width="13px" height="3px" />,
    width: 34,
    minWidth: 34,
    maxWidth: 34,
    accessor: 'actionCell',
    disableSortBy: true,
    Cell: ({ row: { original: port } }: { row: Row<TargetPortEvent> }) => (
      <>
        {port.port &&
          <div className={clsx(styles.center_icon_cell, styles.action_cell)}>
            <PortActionCell port={port.port} />
          </div>
        }
      </>
    ),
  },
];
